/**
 * popup.js --- Pop up div for when clicking on a video media item
 *
 * This component displays the video, metadata, and description
 * corresponding to a video item on the media board
 */

import React, { useContext } from "react"

import Style from "./media.module.scss"
import Styled from "styled-components"

import ReactPlayer from "react-player"

import { MediaPopUpContext } from "../../contexts/MediaPopUp"

// TODO 7: Refactor rich text rendering to nuclear.js
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { INLINES } from "@contentful/rich-text-types"
import { ColoredLink } from "../options"

/**
 * MetaDataColumn: Styled component
 * for video pop-up meta data in order
 * to specify font color and float
 */
const MetaDataColumn = Styled.div`
    display: inline-block;
    width: 50%;
    float: ${props => props.float};
    b {
        color: ${props => props.color}
    }
`

const MediaPopUp = props => {
  // Video pop up  context for visibility
  const [popUpData, setpopUpData] = useContext(MediaPopUpContext)

  // Check if there's no popUpData
  if (popUpData.content === null) {
    return null
  } else {
    console.log(popUpData.content.mediaUrl)
    return (
      <>
        <div
          className={Style.MediaPopUp}
          style={{ visibility: popUpData.visibility }}
        >
          <div className={Style.videoLeftContent}>
            <div
              className={Style.videoBorder}
              style={{ borderColor: props.color }}
            >
              <ReactPlayer
                url={popUpData.content.mediaUrl}
                playing={false}
                controls={true}
                width="48vw"
                height="27vw"
                config={{
                  youtube: {
                    playerVars: {
                      color: props.color,
                    },
                  },
                  vimeo: {
                    playerVars: {
                      color: props.color.substr(1),
                    },
                  },
                }}
              />
            </div>
            <button
              onClick={() =>
                setpopUpData({ visibility: "hidden", content: null })
              }
            >
              <h2 className={Style.backButton}>← [back]</h2>
            </button>
          </div>
          <div className={Style.videoRightContent}>
            <div className="videoMetaData">
              <MetaDataColumn color={props.color} float={"left"}>
                {popUpData.content.thumbnailMetadata.map(
                  (thumbnailMetadata, id) => (
                    <>
                      <b>
                        {thumbnailMetadata
                          .substr(0, thumbnailMetadata.indexOf(":") + 1)
                          .toUpperCase()}
                      </b>
                      <span>
                        {thumbnailMetadata.substr(
                          thumbnailMetadata.indexOf(":") + 1,
                          thumbnailMetadata.length
                        )}
                      </span>
                      <br />
                    </>
                  )
                )}
                <br />
              </MetaDataColumn>
              <MetaDataColumn color={props.color} float={"right"}>
                {popUpData.content.popUpMetadata.map((popUpMetadata, id) => (
                  <>
                    <b>
                      {popUpMetadata
                        .substr(0, popUpMetadata.indexOf(":") + 1)
                        .toUpperCase()}
                    </b>
                    <span>
                      {popUpMetadata.substr(
                        popUpMetadata.indexOf(":") + 1,
                        popUpMetadata.length
                      )}
                    </span>
                    <br />
                  </>
                ))}
                <br />
              </MetaDataColumn>
            </div>
            <div className={Style.videoDescription}>
              <hr />
              {documentToReactComponents(
                popUpData.content.videoDescription.json,
                videoDescriptionOption(props.color)
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default MediaPopUp

/* ===================================================*/

/**
 * videoDescriptionOption: Default rich text parsing options for
 * video descriptions in video popups
 *
 */

const videoDescriptionOption = color => {
  /**
   * descriptionNode: The default description options
   */
  const descriptionNode = {
    renderNode: {
      [INLINES.HYPERLINK]: (node, children) => {
        return (
          <ColoredLink url={node.data.uri} linkText={children} color={color} />
        )
      },
    },
  }
  return descriptionNode
}
